import React from 'react'
import Skillcard from './../Skillcard';
import {motion} from 'framer-motion'
import {skills} from './../data/about_data'
import './about.css'

const About = () => {
    const about_variants = {
        hidden: {
        opacity: 0
    },
        visible: {
            opacity: 1,
            transition : {
            delay: 0.2, transition:0.6
        }
    },
       exit: {
        opacity:0,
        transition : {
            ease: 'easeInOut'
        }
    }
}
    return (
        <motion.div className='about'
        variants = {about_variants}
            initial ='hidden'
            animate = 'visible'
            exit = 'exit'
        >
            <h6 className="about_intro">
                I describe myself as a hardworking, persistant and curious developer. 
                Interested in solving problems and creating efficient solutions.
            </h6>
        <div className="container about_container">
            <h6 className="about_heading">What i offer?</h6>
            <div className="row">
                {
                    skills.map(skill=>
                            <Skillcard skill = {skill} />
                        )
                }
            </div>
        </div>
        </motion.div>
    )
}
export default About;